import {application} from "./application"
import {ToastController} from "./toast_controller";
import {TurboModalController} from "@finchi/turbo-modal";
import {IFrameController} from "./iframe_controller";
import {SidebarController, SimpleBarController, ColorSwitchController} from "@finchi/coreui-stimulus";
import {FlatpickrStimulus} from "./flatpickr_controller";
import {TomSelectController} from "@finchi/tom-select-coreui";
import {TomSelectMultiController} from "./tom_select_multi_controller";
import {ClipboardController} from "./clipboard_controller";
import {AutoSubmitController} from "./auto_submit_controller";
import {SelectNavigateController} from "./select_navigate_controller";
import {FullscreenController} from "./fullscreen_controller";
import {ChartController} from "./chart_controller";
import {IdAustriaStateController} from "./id_austria_state_controller";
import {NavSectionController} from "./nav_section_controller";
import {BridgeAuthenticationController} from "./bridge/authentication_controller";
import {BridgeLogoutController} from "./bridge/logout_controller";
import {BridgeToastController} from "./bridge/toast_controller";
import {BridgeIdAustriaController} from "./bridge/id_austria_controller";
import {BridgeConnectionErrorController} from "./bridge/connection_error_controller";
import {BridgeMenuController} from "./bridge/menu_controller";
import {TrackerMapController} from "../../../../packs/tracker/app/assets/javascripts/controllers/tracker_map_controller";
import {LookupMapController} from "../../../../packs/mobile_triangulation/app/assets/javascripts/controllers/mobile_triangulation/lookup_map_controller";
import {AlarmOrderFormController} from "../../../../packs/fire_department/packs/alarm_order/app/assets/javascripts/controllers/alarm_order_form_controller";
import {AlarmOrderRadioSelect} from "../../../../packs/fire_department/packs/alarm_order/app/assets/javascripts/controllers/alarm_order_radio_select_controller";
import {NestedFormController} from "../../../../packs/fire_department/packs/alarm_order/app/assets/javascripts/controllers/nested_form_controller";
import {AlarmOrderSecondFwController} from "../../../../packs/fire_department/packs/alarm_order/app/assets/javascripts/controllers/alarm_order_second_fw_controller";
import {AlarmOrderAppAlertingController} from "../../../../packs/fire_department/packs/alarm_order/app/assets/javascripts/controllers/alarm_order_app_alerting_controller";
import {AlarmOrderAdditionalResourcesController} from "../../../../packs/fire_department/packs/alarm_order/app/assets/javascripts/controllers/alarm_order_additional_resources_controller";
import {UserMergeFormController} from "../../../../packs/admin/app/assets/javascripts/controllers/user_merge_form_controller";
import {RoleApplicationsController} from "../../../../packs/admin/app/assets/javascripts/controllers/role_applications_controller";
import {RemoteSelectController} from "../../../../packs/admin/app/assets/javascripts/controllers/remote_select_controller";
import {CallDurationController} from "../../../../packs/call_center/app/assets/javascripts/controllers/call_duration_controller";
import {ManualBreakFormController} from "../../../../packs/rescue_service/app/assets/javascripts/controllers/manual_break_form_controller";
import {BreaksRefreshController} from "../../../../packs/rescue_service/app/assets/javascripts/controllers/breaks_refresh_controller";
import {UbimetMapController} from "../../../../packs/weather_monitor/app/assets/javascripts/controllers/weather_monitor/ubimet_map_controller";
import {ImageCycleController} from "../../../../packs/weather_monitor/app/assets/javascripts/controllers/weather_monitor/image_cycle_controller";
import {RadarController} from "../../../../packs/weather_monitor/app/assets/javascripts/controllers/weather_monitor/radar_controller";

application.register("toast", ToastController)
application.register("turbo-modal", TurboModalController)
application.register("iframe", IFrameController)
application.register("sidebar", SidebarController)
application.register("color-switch", ColorSwitchController)
application.register("tom-select", TomSelectController)
application.register("tom-select-multi", TomSelectMultiController)
application.register("flatpickr", FlatpickrStimulus)
application.register("simple-bar", SimpleBarController)
application.register("clipboard", ClipboardController)
application.register("auto-submit", AutoSubmitController)
application.register("select-navigate", SelectNavigateController)
application.register("fullscreen", FullscreenController)
application.register("chart", ChartController)
application.register("id-austria-state", IdAustriaStateController)
application.register("nav-section", NavSectionController)
// Bridge
application.register("bridge--authentication", BridgeAuthenticationController)
application.register("bridge--logout", BridgeLogoutController)
application.register("bridge--toast", BridgeToastController)
application.register("bridge--id-austria", BridgeIdAustriaController)
application.register("bridge--connection-error", BridgeConnectionErrorController)
application.register("bridge--menu", BridgeMenuController)
// Tracker
application.register("tracker-map", TrackerMapController)
// Mobile Triangulation
application.register("mobile-triangulation--lookup-map", LookupMapController)
// Fire Department - Alarm Order
application.register("alarm-order-form", AlarmOrderFormController)
application.register("alarm-order-radio-select", AlarmOrderRadioSelect)
application.register("nested-form", NestedFormController)
application.register("alarm-order-additional-resources", AlarmOrderAdditionalResourcesController)
application.register("alarm-order-second-fw", AlarmOrderSecondFwController)
application.register("alarm-order-app-alerting", AlarmOrderAppAlertingController)
// Admin - User Merges
application.register("user-merge-form", UserMergeFormController)
// Admin - Roles
application.register("role-applications", RoleApplicationsController)
application.register("remote-select", RemoteSelectController)
// Call Center
application.register("call-center--call-duration", CallDurationController)
// Rescue Service
application.register("rescue-service--manual-break-form", ManualBreakFormController)
application.register("rescue-service--breaks-refresh", BreaksRefreshController)
// Weather Monitor
application.register("weather-monitor--ubimet-map", UbimetMapController)
application.register("weather-monitor--image-cycle", ImageCycleController)
application.register("weather-monitor--radar", RadarController)
